import React, { useEffect } from "react";
import { Button, Col, Row, Spin } from "antd";
import ComponentsBreadcrumb from "../../layout/componentsBreadcrumb";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import AppAlert from "../../shared/appAlert";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { fetchPaymentDetails, getPaymentLinkDetails } from "../../reducers/paymentlinkReducer";
import Moment from "react-moment";
import { convertUTCToLocalTime } from "../../utils/service";
import CopyToClipboard from "react-copy-to-clipboard";
import AppText from "../../shared/appText";

const PaymentLinkView = () => {
  const history = useHistory();
  const reducerDispatch = useDispatch();
  const { pathname } = useLocation();
  const _id = pathname?.split('/')[2];
  const _merchantName = pathname?.split('/')[3];
  let viewPaymentDetails = useSelector((state) => state.PayMentReducer.viewPaymentDetails);

  const breadCrumbList = [
    { id: "1", bname: "Payment Artha", url: '/dashboard' },
    { id: '2', bname: 'Payment Links', url: '/paymentlinks' },
    { id: '3', bname:_merchantName }
  ];
  useEffect(() => {
    reducerDispatch(fetchPaymentDetails(_id));
  }, []);
  const redirectToCreatePaymentLink = () =>{
    history.push(`/paymentlinks`)
   }
  const handleErrorMessages=(value)=>{
    reducerDispatch(getPaymentLinkDetails({ key: "viewPaymentDetails", isLoading: false, data: {},error:value }))
  }  
  const getPaymentStateClass = (state) => {
    switch (state) {
      case 'NotPaid':
      case 'Not Paid':
        return 'text-blue';
      case 'Paid':
      case "Partially Paid":
        return 'text-green';
      case 'Failed':
        return 'text-red';
      default:
        return '';
    }
  };
  const renderPaymentDate = (date) => {
    if (!date) {
      return '--';
    }else{
      return (
        <Moment format="DD/MM/YYYY hh:mm:ss A">
          {convertUTCToLocalTime(date)}
        </Moment>
      );
    }
  };
  const renderWalletAddress = (walletAddress) => {
    if (!walletAddress) {
      return '--';
    }else{
      return (
        <CopyToClipboard text={walletAddress} options={{ format: 'text/plain' }}>
          <AppText copyable={{ tooltips: ['Copy', 'Copied'] }} className="summary-text">
            {walletAddress.substring(0, 4)}...{walletAddress.substring(walletAddress.length - 4)}
          </AppText>
        </CopyToClipboard>
      );
    }
  };
  return (
    <>
      <ComponentsBreadcrumb breadCrumbList={breadCrumbList} />
      <div className="payment-link-view">
        {viewPaymentDetails.isLoading ? (
          <div className="text-center">
            <Spin />
            </div>
        ) : (
          <div className="layout-bg right-panel panel-bg tracnsaction-details">
            {viewPaymentDetails.error && (
            <div className="alert-flex" style={{ width: "100%" }}>
                <AppAlert
                    className="w-100 "
                    type="warning"
                    description={viewPaymentDetails.error}
                    showIcon
                />
                <span className="icon sm alert-close" onClick={() => handleErrorMessages(null)}></span>
            </div>
        )}
          <div className='trans-card'>
    
                <div className="d-flex align-items-center">
                  <span className="icon lg btn-arrow-back c-pointer" onClick={redirectToCreatePaymentLink}></span>
                  <span className="card-title card-head"> Payment Links Details  </span>
                </div>
            <Row gutter={[4, 4]} className='summary-content tx-space transaction-summary'>
    
              <Col xs={24} sm={24} md={24} lg={24} xxl={24} >
                <div className="summary-list-item">
                  <div className=" summary-label">Merchant</div>
                  <div className=" summary-text">{viewPaymentDetails?.data?.merchantName || '--'}</div>
                </div>
              </Col>
              <Col xs={24} sm={24} md={24} lg={24} xxl={24} >
                <div className="summary-list-item">
                  <div className=" summary-label">Payment Type</div>
                  <div className=" summary-text">{viewPaymentDetails?.data?.invoiceType || '--'}</div>
                </div>
              </Col>
    
    
              <Col xs={24} sm={24} md={24} lg={24} xxl={24} >
                <div className="summary-list-item">
                  <div className=" summary-label">Order ID</div>
                  <div className=" summary-text">{viewPaymentDetails?.data?.orderId || '--'}</div>
                </div>
              </Col>
              <Col xs={24} sm={24} md={24} lg={24} xxl={24} >
                <div className="summary-list-item">
                  <div className=" summary-label">Amount</div>
                  <div className=" summary-text">{viewPaymentDetails?.data?.amount || '--'}</div>
                </div>
              </Col>
    
              <Col xs={24} sm={24} md={24} lg={24} xxl={24} >
                <div className="summary-list-item">
                  <div className=" summary-label">Coin</div>
                  <div className={`summary-text`}>{viewPaymentDetails?.data?.currency || '--'}</div>
                </div>
              </Col> 
              <Col xs={24} sm={24} md={24} lg={24} xxl={24} >
                <div className="summary-list-item">
                  <div className=" summary-label">Network</div>
                  <div className={`summary-text`}>{viewPaymentDetails?.data?.networkName || '--'}</div>
                </div>
              </Col> 
              <Col xs={24} sm={24} md={24} lg={24} xxl={24} >
                <div className="summary-list-item">
                  <div className=" summary-label">Date</div>
                  <div className={`summary-text`}>
                  {renderPaymentDate(viewPaymentDetails?.data?.date)}
                  </div>
                </div>
              </Col>
              <Col xs={24} sm={24} md={24} lg={24} xxl={24} >
                <div className="summary-list-item">
                  <div className=" summary-label">Wallet Address</div>
                  <div className={`summary-text`}>
                  {renderWalletAddress(viewPaymentDetails?.data?.walletAddress)}
                  </div>
                </div>
              </Col>
              <Col xs={24} sm={24} md={24} lg={24} xxl={24} >
                <div className="summary-list-item">
                  <div className=" summary-label">Status</div>
                  <div className={`summary-text ${getPaymentStateClass(viewPaymentDetails?.data?.state)}`}>{viewPaymentDetails?.data?.state || '--'}</div>
                </div>
              </Col>
            </Row>
            <div className="text-right mb-24">
              <Button className="outlined-btn payee-popup pop-btn mr-8"  onClick={redirectToCreatePaymentLink}>
                Cancel
              </Button>
    
            </div>
    
          </div>
        </div>
        )}
      </div>
    </>
  );
};

export default PaymentLinkView;
